export const NAME = 'partner';

export const REMISE_TYPE_SIMPLE = 1;
export const REMISE_TYPE_SIMPLE_BOOST = 2;
export const REMISE_TYPE_MULTIREMISE = 4;
export const REMISE_TYPE_MULTIREMISE_BOOST = 5;

/**
 * Here goes the actionTypes
 */

export const REQUEST_PARTNERS = 'REQUEST_PARTNERS';
export const RECEIVE_PARTNERS = 'RECEIVE_PARTNERS';
export const FAILURE_PARTNERS = 'FAILURE_PARTNERS';

export const REQUEST_PARTNER_DETAILS = 'REQUEST_PARTNER_DETAILS';
export const RECEIVE_PARTNER_DETAILS = 'RECEIVE_PARTNER_DETAILS';
export const FAILURE_PARTNER_DETAILS = 'FAILURE_PARTNER_DETAILS';



// WEBPACK FOOTER //
// ./src/services/partner/constants.js